export default {
  namespaced: true,

  state: {
    items: null,
    loading: false,
    permissions: null,
    pageButtonsPermissions:null
  },

  getters: {
    
    items: (state) => state.items,
    loading: (state) => state.loading,
    permissions: (state) => state.permissions,
    pageButtonsPermissions:(state)=>state.pageButtonsPermissions
  },

  mutations: {

  },

  actions: {
    setItems ({ state }, items) {
      
      state.items = items
       
    },

    setPermissions ({ state }, permissions) {
      state.permissions = permissions
    },

    loading ({ state }, loading) {
      state.loading = true
    },

    setPageButtonsPermissions ({ state }, pageButtonsPermissions) {
      state.pageButtonsPermissions = pageButtonsPermissions
    }


  }
}
